import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=2b057420"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&id=2b057420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports